import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=6051a577&scoped=true&"
import script from "./BigNumber.vue?vue&type=script&lang=js&"
export * from "./BigNumber.vue?vue&type=script&lang=js&"
import style0 from "./BigNumber.vue?vue&type=style&index=0&id=6051a577&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051a577",
  null
  
)

export default component.exports